import type { App } from "vue";

export function mountAppendTo(app: App, target: Element) {
    const replacement = document.createElement("div");
    target.appendChild(replacement);
    mountReplace(app, replacement);
}

export function mountReplace(
    app: App,
    target: Element | string | undefined = undefined
) {
    if (typeof target === "string") {
        const newTarget = document.querySelector(target);
        if (!newTarget) {
            throw new Error(`Target element "${target}" not found`);
        }
        target = newTarget;
    }

    const fragment = document.createDocumentFragment();

    const result = app.mount(fragment);

    if (target) {
        if (!target.parentNode)
            throw new Error("Error: target element has no parent node");

        target.parentNode.replaceChild(fragment, target);
    }

    return result;
}
